// extracted by mini-css-extract-plugin
module.exports = {"warrantyBadgeButton":"az_TFb","warrantyBadgeText":"az_UFb","smallPadding":"az_VFb"};